import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import css from '../index.scss';
import courseCSS from '../styles/course-topics.scss';
import withModal from '../../with-modal';
import CourseDetails from '../../course-topics-details';
import Button from '../../button';
import { DARK } from '../../button/variants';
import messages from '../messages';

const ViewCourseModal = ({ courseDetails, intl, hideCourseDetails }) => (<div className={css.courseDetailModal}>
    <div className={css.courseDetailContent}>
        <CourseDetails course={courseDetails} css={courseCSS} />
    </div>
    <div className={css.courseDetailFooter}>
        <Button
            handleOnClick={hideCourseDetails}
            label={intl.formatMessage(messages.backButton)}
            variant={DARK}
        />
    </div>
</div>
);

ViewCourseModal.propTypes = {
    courseDetails: PropTypes.object,
    hideCourseDetails: PropTypes.func.isRequired,
    intl: intlShape.isRequired
};

export default withModal('show')(injectIntl(ViewCourseModal));



// WEBPACK FOOTER //
// ./app/components/manage-assigned-course/modal/view-course.js